"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Metadata = void 0;
class Metadata {
}
exports.Metadata = Metadata;
//# sourceMappingURL=metadata.model.js.map